export const BrandSafetyAndPageQualityTargetingType = {
    concepts: {
        label: 'Concepts',
        key: 'concepts'
    },
    conceptSet: {
        label: 'Concept Set',
        key: 'conceptSet'
    }
}